import React from 'react';

import { Auth, I18n } from 'aws-amplify';

import {
  AuthPiece,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  ButtonRow,
  MessageRow,
} from 'aws-amplify-react';

import LogoArea from './logoarea.js';

export default class CheckPassView extends AuthPiece {
  constructor (props) {
    super(props);
    this.state = {
      errorStr: '',
    };
    this.inputs = {};
    this._validAuthStates = ['checkpass'];
  }
  checkError = () => {
    if (!this.inputs.hasOwnProperty('password')) {
      const tmpStr = I18n.get('Enter your password');
      this.setState({
        errorStr: tmpStr
      });
      return true;
    }
    if ('' === this.inputs.password) {
      const tmpStr = I18n.get('Enter your password');
      this.setState({
        errorStr: tmpStr
      });
      return true;
    }
  }
  toSecond = () => {
    if (this.checkError()) {
      return;
    }
    Auth.signIn(this.props.authData, this.inputs.password).then((user) => {
      const userData = {
        username: this.props.authData,
        pw: this.inputs.password
      };
      const datum = {
        user, userData,
      };
      Auth.signOut().then(()=>this.changeState('secondSignUp', datum));
    }).catch(err=>{
      let tmpStr = '';
      if (err.hasOwnProperty('message')) {
        tmpStr = I18n.get(err.message);
      } else if(err.hasOwnProperty('code')){
        tmpStr = I18n.get(err.code);
      }
      this.setState({
        errorStr: tmpStr,
      })
    });
  }
  handleInputChange(evt) {
    const { name, value } = evt.target;
    this.inputs[name] = value;
  }
  showComponent(theme) {
    return (
      <div className="loginContainer">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>
            {I18n.get('Check password')}
          </SectionHeader>
          <SectionBody theme={theme}>
            <div className="fontSizeSmall colNatural01">
              <MessageRow>{I18n.get('Enter your password')}</MessageRow>
            </div>
            <label className="loginLabel">{I18n.get('Password')}</label>
            <InputRow
              placeholder={I18n.get('Password')}
              theme={this.props.theme}
              type="password"
              key="password"
              name="password"
              onChange={this.handleInputChange}
            />
            <p className='errorText'>{this.state.errorStr}</p>
            <ButtonRow style={theme.loginLargeButton} onClick={this.toSecond} theme={theme} >
              {I18n.get('Next')}
            </ButtonRow>
          </SectionBody>
          <SectionFooter theme={theme}>
          </SectionFooter>
        </FormSection>
      </div>
    )
  }
}
